module.exports = "<p>\r\n    Redirecting...\r\n</p>"